import React, { useContext } from 'react';
import { Link } from 'gatsby';
import './ProductCard.scss';
import {CartController} from "../../../../helpers/CartController";
import { CartContext } from '../../../../context/CartContext';

const ProductCard = ({data}) => {
  console.log(data);

  const {setCartCount, setShowShoppingCart} = useContext(CartContext);
  const addToCartFromList = () => {
    // const resp = CartController.addOneMoreItemToCart(data, 'es');
    setCartCount(CartController.getOrCreateCartIfNoExits('es').items.length);
    setShowShoppingCart((prev) => !prev);
  }
  return (
    <div className={`product ${data.stockStatus === 'OUT_OF_STOCK' ? 'sold-out' : ''}`}>
      <picture>
        <img
          className="featuredImage"
          // src={""} // PROBLEMS
          src={data.image.sourceUrl} // PROBLEMS
          alt={`Imagen principal del producto ${data.name}`}
        />
      </picture>
      <div className="product-content">
        <Link to={`/tienda/${data.slug}`}>
          <span>
            Ver detalle <i className="icon icon-arrow-right--white"></i>
          </span>
        </Link>

        <div className="summary">
          <div className="information">
            <h4 className="title">{ data.name }</h4>
            <p className="price" dangerouslySetInnerHTML={{ __html: data.price }}></p>
          </div>
          <button  className="btn-add" aria-label="Agregar al carrito"
                  data-product-id={data.databaseId} data-product-stocl={data.stockQuantity}>
            <i className="icon icon-bag-add"
               onClick={addToCartFromList}
               data-product-id={data.databaseId} data-product-stocl={data.stockQuantity}>
            </i>
          </button>
        </div>
      </div>
    </div>
  );
};
export default ProductCard;